/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Online/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Online({
  children,
  viewPath = "/App/Form/Connection/Online"
  
}) {
  return null
}